import { render, staticRenderFns } from "./vat-id-details.vue?vue&type=template&id=58d1defa&lang=pug"
import script from "./vat-id-details.vue?vue&type=script&lang=ts"
export * from "./vat-id-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports